<div class="dialog-content-wrapper">
  <form [formGroup]="editForm" class="k-form-inline">

    <div class="k-form-field" *ngIf="mode !== formModes.COPY">
      <label class="form-label col-3 k-label" for="discipline_id">Discipline</label>
      <div class="col-8">
        <kendo-dropdownlist id="discipline_id" formControlName="discipline_id" [data]="disciplines"
          [valuePrimitive]="true" textField="discipline_name" valueField="id"
          [defaultItem]="{ id: null, discipline_name: 'Select...' }" appAutoFocus>
        </kendo-dropdownlist>
        <div *ngIf="discipline_id?.invalid" class="alert alert-danger">
          <div *ngIf="discipline_id?.errors?.['required']">Discipline required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field">
      <label class="form-label col-3 k-label" for="evaluation_name">{{mode == formModes.COPY ? 'New' : ''}} Evaluation
        Name</label>
      <div class="col-8">
        <input type="text" id="evaluation_name" formControlName="evaluation_name" class="form-control" appAutoFocus>
        <div *ngIf="evaluation_name?.invalid" class="alert alert-danger">
          <div *ngIf="evaluation_name?.errors?.['required']">{{mode == formModes.COPY ? 'New' : ''}} Evaluation Name is
            required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field" *ngIf="mode !== formModes.COPY">
      <label class="form-label col-3 k-label" for="comment">Comment</label>
      <div class="col-8">
        <textarea class="form-control" id="comment" formControlName="comment" rows="4" style="width:100%;"></textarea>
      </div>
    </div>

    <div class="k-form-field" *ngIf="mode !== formModes.COPY">
      <label class="form-label col-3 k-label" for="comment">Instructions</label>
      <div class="col-8">
        <kendo-editor [value]="value" style="height: 400px;" (valueChange)="valueChange($event)">
          <kendo-toolbar>
            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
              <!--          <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>-->
            </kendo-toolbar-buttongroup>
            <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
            <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
          </kendo-toolbar>
        </kendo-editor>
        <input hidden type="text" class="form-control" formControlName="participant_instruction"
          id="participant_instruction">
        <div *ngIf="participant_instruction?.invalid" class="alert alert-danger">
          <div *ngIf="participant_instruction?.errors?.['required']">Instructions are required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field" *ngIf="mode !== formModes.COPY">
      <label class="form-label col-3 k-label" for="domain_instruction_student">Domain Instructions - Student</label>
      <div class="col-8">
        <textarea class="form-control" id="domain_instruction_student" formControlName="domain_instruction_student"
          rows="4" style="width:100%;"></textarea>
        <div *ngIf="domain_instruction_student?.invalid" class="alert alert-danger">
          <div *ngIf="domain_instruction_student?.errors?.['required']">Domain Instructions - Student are required.
          </div>
        </div>
      </div>
    </div>

    <div class="k-form-field" *ngIf="mode !== formModes.COPY">
      <label class="form-label col-3 k-label" for="domain_instruction_supervisor">Domain Instructions -
        Supervisor</label>
      <div class="col-8">
        <textarea class="form-control" id="domain_instruction_supervisor"
          formControlName="domain_instruction_supervisor" rows="4" style="width:100%;"></textarea>
        <div *ngIf="domain_instruction_supervisor?.invalid" class="alert alert-danger">
          <div *ngIf="domain_instruction_supervisor?.errors?.['required']">Domain Instructions - Supervisor are
            required.</div>
        </div>
      </div>
    </div>

    <div class="k-form-field" *ngIf="mode !== formModes.COPY">
      <label class="form-label col-3 k-label" for="domain_instruction_professional">Domain Instructions -
        Professional</label>
      <div class="col-8">
        <textarea class="form-control" id="domain_instruction_professional"
          formControlName="domain_instruction_professional" rows="4" style="width:100%;"></textarea>
        <div *ngIf="domain_instruction_professional?.invalid" class="alert alert-danger">
          <div *ngIf="domain_instruction_professional?.errors?.['required']">Domain Instructions - Professional are
            required.</div>
        </div>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="editForm.errors?.['duplicateEvaluation']">
      That evaluation already exists.
    </div>
  </form>
</div>


<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
  <!--  <button kendoButton (click)="onSaveAction()" class="btn btn-primary">Save</button>-->
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
